<template>
  <Transition name="modal">
    <div class="modal-mask" @click="close()">
      <div class="modal-wrapper">
        <div class="modal-container" @click.stop>
          <div class="modal-header">
            <a href="javascript: void(0)" class="modal-default-button" @click="close()">
              <i class="material-icons">
                clear
              </i>
            </a>
          </div>
          <div class="modal-body">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    absolute: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  created() {
    this.zoomDisable()
  },
  mounted() {
  },
  beforeDestroy() {
    this.zoomEnable()
  },
  methods: {
    close() {
      this.$emit('close')
      this.zoomEnable()
    },
    zoomDisable() {
      document.body.style.overflow = 'hidden'
      var viewport = document.querySelector('meta[name=viewport]')
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0')
    },
    zoomEnable() {
      document.body.style.overflow = ''
      var viewport = document.querySelector('meta[name=viewport]')
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=1')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .85);
  display: table;
  transition: opacity .3s ease;
  &.without-close-btn{
    .modal-container{
      border-radius: 4px;
      padding: 0;
    }
    .modal-header{
      display: none;
      padding: 24px;
      .modal-default-button{
        top: 24px;
        right: 24px;
      }
    }
    .modal-body {
      padding: 0;
    }
  }
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  height: 100%;
}

.modal-container {
  width: 690px;
  max-height: 90vh;
  overflow-y: scroll;
  margin: 0 auto;
  padding: 24px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.27);
  transition: all .3s ease;
  //FOR FIREFOX
  &.absolute {
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.modal-header{
  position: relative;
  height: 24px;
  line-height: 24px;
  .modal-default-button {
    position: absolute;
    top: 0;
    right: 0;
    i{
      color: $grey-9b;
    }
  }
}

.modal-body {
  padding: 24px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media only screen and (max-width: 767.98px) {
  .modal-container {
    width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
    box-shadow: none;
  }
  .modal-body {
    padding: 24px 0;
  }
  .modal-mask {
    &.without-close-btn{
      .modal-header{
        display: block;
        z-index: 1;
      }
    }
  }
}
</style>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.mk-modal{
  .modal-body {
    .title{
      font-size: 24px;
      font-weight: 500;
      line-height: 1.6;
      color: $grey-50;
      margin: 12px 0 20px;
    }
    .desp{
      font-size: 20px;
      font-weight: normal;
      line-height: 1.6;
      color: $grey-50;
      margin-bottom: 64px;
    }
    .btn-group{
      display: block;
      width: 100%;
      .mk-btn{
        float: right;
        margin-left: 24px;
      }
      &:after{
        content: "";
        display: block;
        clear: both;
      }
    }
  }
  &--share{
    .share-content{
      margin-bottom: 36px;
      .cover{
        width: 130px;
        height: 116px;
        float: left;
        border-radius: 12px;
        overflow: hidden;
        img{
          width: 100%;
          height: auto;
        }
      }
      .info{
        overflow: hidden;
        padding-left: 12px;
        .title{
          font-size: 20px;
          font-weight: 500;
          line-height: 1.6;
          color: $grey-50;
          margin: 0 0 8px;
        }
        .author{
          font-size: 12px;
          font-weight: 500;
          line-height: 1.67;
          color: $grey-7d;
          margin: 0;
        }
      }
      &:after{
        content: "";
        display: block;
        clear: both;
      }
    }
    .social-media{
      margin-bottom: 24px;
      .icon {
        display: inline-block;
        vertical-align: top;
        height: 40px;
        width: 40px;
        margin-right: 24px;
        cursor: pointer;
        overflow: hidden;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
    .copy-link{
      position: relative;
      input{
        width: 100%;
        height: 44px;
        border: 1px solid $grey-ec;
        border-radius: 4px;
        padding: 8px 16px;
        font-size: 16px;
        font-weight: bold;
        color: $grey-9b;
        caret-color: $theme-yellow;
        outline: none;
        &::selection {
          background-color: rgba(244, 185, 59, 0.28);
        }
      }
      .mk-btn{
        position: absolute;
        width: 128px;
        height: 44px;
        top: 0;
        right: 0;
        font-size: 16px;
        border-radius: 4px;
        line-height: 44px;
        outline: none;
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .mk-modal{
    .modal-body {
      .btn-group{
        .mk-btn{
          width: calc(50% - 12px);
          margin-left: 12px;
          &+.mk-btn{
            margin: 0 12px 0 0;
          }
        }
      }
    }
  }
}
</style>
